module.exports = __webpack_public_path__ + "img/event_mobile_6.d86ad7ba.png";